import React from 'react';
import { Typography } from '@mui/material';
import { List as ListComponent, ListItem } from './styles';

export const Item = ({ children }) => (
  <Typography
    variant='body2' component={ListItem} data-testid='list-item'>
    {children}
  </Typography>
);

export const List = Object.assign(ListComponent, {
  Item,
});
